<template>
  <el-container>
    <el-header>
      <el-card>
        <div style="margin-top: 10px">
          <el-button type="primary" @click="portDialog=true,reset()">新增</el-button>
        </div>
        <el-dialog :visible.sync="portDialog" v-if="portDialog">
          <div><span>串口描述:</span><el-input v-model="portDescription1" style="width: 300px" :disabled="disable"></el-input></div>
          <div style="margin-top: 20px"><span>串口名:</span>
            <el-select v-model="portName1">
              <el-option v-for="item in serverPort" :label="item" :value="item"></el-option>
            </el-select></div>
          <div style="margin-top: 20px"><span>波特率:</span>
            <el-select v-model="baudrate1">
              <el-option v-for="item in baudrateList" :label="item" :value="item"></el-option>
            </el-select></div>
          <div style="margin-top: 20px"><span>串口功能:</span>
            <el-select v-model="portFunc">
              <el-option v-for="item in portFunction" :label="item" :value="item"></el-option>
            </el-select></div>
          <div style="margin-top: 20px"><span>是否只读:</span>
            <el-select v-model="readOnly">
              <el-option v-for="item in readOnly1" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addPort">确认</el-button>
            <el-button @click="portDialog = false">取消</el-button>
          </div>
        </el-dialog>
      </el-card>

    </el-header>
    <el-main style="margin-top: 30px">
      <el-card>
        <el-table :data="portList">
          <el-table-column prop="_id" label="id" v-if="false"></el-table-column>
          <el-table-column prop="portDes" label="串口描述"></el-table-column>
          <el-table-column prop="portName" label="串口名"></el-table-column>
          <el-table-column prop="baudrate" label="波特率"></el-table-column>
          <el-table-column prop="portFunction" label="串口功能"></el-table-column>
          <el-table-column prop="readOnly" label="是否只读"></el-table-column>
          <el-table-column prop="user" label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.user"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="stateChange(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="updatePort(scope.row),portDialog=true">修改</el-button>
              <el-button type="primary" size="mini" @click="deletePort(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'portSetting',
    data(){
      return{
        disable:false,
        portDescription:'',
        portDescription1:'',
        portDescription2:'',
        portName:'',
        portName1:'',
        portName2:'',
        portList:'',
        readOnly:'',
        readOnly1:['是','否'],
        portDialog:false,
        updateDialog:false,
        serverPort:[],
        portFunc:'',
        portFunc1:'',
        portFunction:[],
        baudrate1:'',
        baudrate2:'',
        baudrateList:[110,300,600,1200,2400,4800,9600,14400,19200,38400,56000,57600,115200,128000,230400,256000,460800,500000,512000,600000,750000,921600,1000000,1500000,2000000],
        getServerPortList:{
          "version": 1,
          "method": "rxtx.GetPortList",
          "params": {},
          "token": "",
          "id": 0
    },
        getPortFunc:{
          "version": 1,
          "method": "rxtx.PortFunction",
          "params": {},
          "token": "#",
          "id": 0
    },
        getPort:{
          "version": 1,
          "method": "rxtx.GetPortInfo",
          "params": {},
          "token": "#",
          "id": 0
    },
        add:{
          "version": 1,
          "method": "rxtx.AddPortInfo",
          "params": {
	          "portDes":"",
            "portName":"",
            "baudrate":"",
            "portFunction":"",
            "readOnly":""
          },
          "token": "#",
          "id": 0
    },
        delete:{
          "version": 1,
          "method": "rxtx.DelPortInfo",
          "params": {
	          "_id":""
          },
          "token": "#",
          "id": 0
    },
        portOpen:{
          "version": 1,
          "method": "rxtx.OpenPort",
          "params": {
            "portId":"",
		        "portName":"",
            "baudrate":"",
            "portFunction":"",
            "readOnly":""
            },
            "token": "#",
            "id": 0
    },
        portClose:{
          "version": 1,
          "method": "rxtx.ClosePort",
          "params": {
            "portId":"",
            "portName":"",
          },
          "token": "#",
          "id": 0
        }
      }
    },
    methods:{
      reset(){
        this.portDescription1 = '';
        this.baudrate1 = '';
        this.portFunc = '';
        this.portName1 = '';
        this.readOnly='';
        this.disable = false;
      },
      getPortList(){
        this.$axios.post(this.$mainUrl,this.getPort).then(res=>{
          if(res.data.hasOwnProperty('result')){
            for(let i=0;i<res.data.result.portInfoList.length;i++){
              if(res.data.result.portInfoList[i].readOnly == true){
                res.data.result.portInfoList[i].readOnly = "是"
              }else{
                res.data.result.portInfoList[i].readOnly= "否"
              }
            }
            this.portList = res.data.result.portInfoList;
          }
        })
      },
      getServerPort(){
        this.$axios.post(this.$mainUrl,this.getServerPortList).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.serverPort = res.data.result.ports;
          }
        })
      },
      getPortFunction(){
        this.$axios.post(this.$mainUrl,this.getPortFunc).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.portFunction = res.data.result.portFunction;
          }
        })
      },
      addPort(){
          this.add.params.portDes = this.portDescription1;
          this.add.params.baudrate = parseInt(this.baudrate1);
          this.add.params.portFunction = this.portFunc;
          this.add.params.portName = this.portName1;
          if(this.readOnly == '是'){
            this.add.params.readOnly = true;
          }else {
            this.add.params.readOnly = false;
          }
          for (let key in this.add.params) {
           if (this.add.params[key] === "") {
              this.add.params[key] = null;
           }
          };
          this.$axios.post(this.$mainUrl,this.add).then(res=>{
            if (res.data.hasOwnProperty('result')){
              this.$message({
                type:'success',
                message:'新增成功'
              })
              this.portDialog = false;
              this.getPortList()
            }else {
              this.$message({
                type:'error',
                message:'新增失败'
              })
            }
          })
      },
      updatePort(val){
        this.disable = true;
        this.portDescription1 = val.portDes;
        this.baudrate1 = val.baudrate;
        this.portFunc = val.portFunction;
        this.portName1 = val.portName;
        this.readOnly = val.readOnly;
      },
      deletePort(val){
        this.delete.params._id = val._id;
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$mainUrl,this.delete).then(res=>{
            if(res.data.hasOwnProperty('result')){
              this.$message({
                type:'success',
                message:'删除成功'
              })
              this.getPortList()
            }else{
              this.$message({
                type:'error',
                message:'删除失败'
              })
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })

        })
      },
      stateChange(val){
        if(val.user == true){
          this.portOpen.params.portId = val._id;
          this.portOpen.params.baudrate = parseInt(val.baudrate);
          this.portOpen.params.portFunction = val.portFunction;
          this.portOpen.params.portName = val.portName;
          if(this.readOnly == '是'){
            this.portOpen.params.readOnly = true;
          }else {
            this.portOpen.params.readOnly = false;
          }
          for (let key in this.portOpen.params) {
            if (this.portOpen.params[key] === "") {
              this.portOpen.params[key] = null;
            }
          };
          this.$axios.post(this.$mainUrl,this.portOpen).then(res=>{
            if(res.data.hasOwnProperty('result')){

              this.$message({
                type:'success',
                message:'串口开启成功'
              })
            }else{
              val.user = false;
              this.$message({
                type:'error',
                message:res.data.error.message
              })
            }
          })
        }
        if(val.user == false){
          this.portClose.params.portId = val._id;
          this.portClose.params.portName = val.portName;
          for (let key in this.portClose.params) {
            if (this.portClose.params[key] === "") {
              this.portClose.params[key] = null;
            }
          };
          this.$axios.post(this.$mainUrl,this.portClose).then(res=>{
            if(res.data.hasOwnProperty('result')){
              this.$message({
                type:'success',
                message:'串口关闭成功'
              })
            }else{
              val.user = true
              val.user = false;
              this.$message({
                type:'error',
                message:res.data.error.message
              })
            }
          })
        }
      }
    },
    mounted () {
      this.getPortList()
      this.getServerPort();
      this.getPortFunction()
    }
  }
</script>

<style scoped>

</style>
